// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-order-page {
  display: flex;
  flex-direction: column;
  gap: 101px;
  align-items: flex-start;
}
.search-order-page .top-block {
  padding-top: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
}
@media (min-width: 769px) {
  .search-order-page .top-block {
    max-width: 487px;
  }
}
.search-order-page .top-block .hr {
  width: 1px;
  background: #DEDEDE;
}
@media (max-width: 974px) {
  .search-order-page .top-block .hr {
    display: none;
  }
}
.search-order-page .top-block .sign-in-block,
.search-order-page .top-block .order-lookup-block {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  padding: 0 30px;
}
@media (min-width: 600px) {
  .search-order-page .top-block .sign-in-block,
  .search-order-page .top-block .order-lookup-block {
    padding: 0 40px;
  }
}
@media (min-width: 640px) {
  .search-order-page .top-block .sign-in-block,
  .search-order-page .top-block .order-lookup-block {
    padding: 0 60px;
  }
}
@media (min-width: 769px) {
  .search-order-page .top-block .sign-in-block,
  .search-order-page .top-block .order-lookup-block {
    padding: 0 15px 0 32px;
  }
}
@media (min-width: 1279px) {
  .search-order-page .top-block .sign-in-block,
  .search-order-page .top-block .order-lookup-block {
    padding: 0 15px 0 62px;
  }
}
.search-order-page .top-block .sign-in-block .title,
.search-order-page .top-block .order-lookup-block .title {
  color: #062743;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.search-order-page .top-block .sign-in-block .input,
.search-order-page .top-block .order-lookup-block .input {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 5px;
}
.search-order-page .top-block .sign-in-block .input .label,
.search-order-page .top-block .order-lookup-block .input .label {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.search-order-page .top-block .sign-in-block .input .custom-input,
.search-order-page .top-block .order-lookup-block .input .custom-input {
  width: auto !important;
  border: 2px solid #D9D9D9;
  background: #FFF;
  height: 40px;
  padding: 0px 15px;
  font-size: 16px;
}
@media (max-width: 460px) {
  .search-order-page .top-block .sign-in-block .input .custom-input,
  .search-order-page .top-block .order-lookup-block .input .custom-input {
    width: 330px;
  }
}
@media (max-width: 380px) {
  .search-order-page .top-block .sign-in-block .input .custom-input,
  .search-order-page .top-block .order-lookup-block .input .custom-input {
    width: 250px;
  }
}
@media (max-width: 300px) {
  .search-order-page .top-block .sign-in-block .input .custom-input,
  .search-order-page .top-block .order-lookup-block .input .custom-input {
    width: 100%;
  }
}
.search-order-page .top-block .sign-in-block .input .input-container,
.search-order-page .top-block .order-lookup-block .input .input-container {
  position: relative;
}
.search-order-page .top-block .sign-in-block .input .input-container .forgot-password-link,
.search-order-page .top-block .order-lookup-block .input .input-container .forgot-password-link {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #062743;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
}
.search-order-page .bottom-block {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: center;
  justify-content: center;
  border: 1px solid #D9D9D9;
  background: #FFF;
  padding: 30px 122px;
  max-width: 100%;
}
@media (max-width: 960px) {
  .search-order-page .bottom-block {
    gap: 20px;
  }
}
@media (max-width: 960px) {
  .search-order-page .bottom-block {
    padding: 20px;
  }
}
.search-order-page .bottom-block .text {
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/search-order-page.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,UAAA;EACA,uBAAA;AACD;AACC;EACC,cAAA;EACE,WAAA;EACF,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AACF;AACE;EARD;IASE,gBAAA;EAED;AACF;AAAE;EACC,UAAA;EACA,mBAAA;AAEH;AAAG;EAJD;IAKE,aAAA;EAGF;AACF;AAAE;;EAEC,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACE,eAAA;AAEL;AAAG;EATD;;IAUE,eAAA;EAIF;AACF;AAFG;EAbD;;IAcE,eAAA;EAMF;AACF;AAJG;EAjBD;;IAkBE,sBAAA;EAQF;AACF;AANG;EArBD;;IAsBE,sBAAA;EAUF;AACF;AARG;;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAWJ;AARG;;EACC,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;AAWJ;AATI;;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAYL;AATI;;EACC,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAYL;AAVK;EARD;;IASE,YAAA;EAcJ;AACF;AAZK;EAZD;;IAaE,YAAA;EAgBJ;AACF;AAdK;EAhBD;;IAiBE,WAAA;EAkBJ;AACF;AAfI;;EACC,kBAAA;AAkBL;AAhBK;;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAmBN;AAZC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAcF;AAZE;EAXD;IAYE,SAAA;EAeD;AACF;AAbE;EAfD;IAgBE,aAAA;EAgBD;AACF;AAdE;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAgBH","sourcesContent":[".search-order-page {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 101px;\n\talign-items: flex-start;\n\n\t.top-block {\n\t\tpadding-top: 0;\n  \t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: center;\n\t\tgap: 50px;\n\n\t\t@media (min-width: 769px) {\n\t\t\tmax-width: 487px;\n\t\t}\n\n\t\t.hr {\n\t\t\twidth: 1px;\n\t\t\tbackground: #DEDEDE;\n\n\t\t\t@media (max-width: 974px) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t.sign-in-block,\n\t\t.order-lookup-block {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: 20px;\n\t\t\twidth: 100%;\n  \t\t\tpadding: 0 30px;\n\n\t\t\t@media (min-width: 600px) {\n\t\t\t\tpadding: 0 40px;\n\t\t\t}\n\n\t\t\t@media (min-width: 640px) {\n\t\t\t\tpadding: 0 60px;\n\t\t\t}\n\n\t\t\t@media (min-width: 769px) {\n\t\t\t\tpadding: 0 15px 0 32px;\n\t\t\t}\n\n\t\t\t@media (min-width: 1279px) {\n\t\t\t\tpadding: 0 15px 0 62px;\n\t\t\t}\n\n\t\t\t.title {\n\t\t\t\tcolor: #062743;\n\t\t\t\tfont-family: Inter;\n\t\t\t\tfont-size: 22px;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tline-height: 24px;\n\t\t\t}\n\n\t\t\t.input {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\tgap: 5px;\n\n\t\t\t\t.label {\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t}\n\n\t\t\t\t.custom-input {\n\t\t\t\t\twidth: auto !important;\n\t\t\t\t\tborder: 2px solid #D9D9D9;\n\t\t\t\t\tbackground: #FFF;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tpadding: 0px 15px;\n\t\t\t\t\tfont-size: 16px;\n\n\t\t\t\t\t@media (max-width: 460px) {\n\t\t\t\t\t\twidth: 330px;\n\t\t\t\t\t}\n\n\t\t\t\t\t@media (max-width: 380px) {\n\t\t\t\t\t\twidth: 250px;\n\t\t\t\t\t}\n\n\t\t\t\t\t@media (max-width: 300px) {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.input-container {\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t.forgot-password-link {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tright: 10px;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\tcolor: #062743;\n\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\ttext-decoration-line: underline;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.bottom-block {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\ttext-align: center;\n\t\tjustify-content: center;\n\t\tborder: 1px solid #D9D9D9;\n\t\tbackground: #FFF;\n\t\tpadding: 30px 122px;\n\t\tmax-width: 100%;\n\n\t\t@media (max-width: 960px) {\n\t\t\tgap: 20px;\n\t\t}\n\n\t\t@media(max-width: 960px) {\n\t\t\tpadding: 20px;\n\t\t}\n\n\t\t.text {\n\t\t\tcolor: #000;\n\t\t\tfont-family: Inter;\n\t\t\tfont-size: 16px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 24px;\n\t\t\ttext-align: left;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
